module.exports = __webpack_public_path__ + "assets/img/CMTP-Website.74e1d1cc.jpg";